import { Injectable } from '@angular/core';

/** Something that can be closed — the popover registers itself with this shape. */
export interface NxClosable {
  close(): void;
}

/**
 * Ensures at most one popover is open at a time: opening a new one closes the previous.
 */
@Injectable({ providedIn: 'root' })
export class NxPopoverService {
  private current: NxClosable | null = null;

  register(popover: NxClosable): void {
    if (this.current && this.current !== popover) {
      this.current.close();
    }
    this.current = popover;
  }

  unregister(popover: NxClosable): void {
    if (this.current === popover) {
      this.current = null;
    }
  }
}
